import { useMediaQuery } from "@chakra-ui/react"

const useMq = bp => useMediaQuery(`(min-width: ${bp})`)

export default useMq
